import { Typography } from "@/core/components/ui/typography";

interface InfoPairProps {
  label: string;
  info?: string | null;
}

const InfoPair = ({ label, info }: InfoPairProps) => (
  <Typography variant="bodyW2">
    <span className="text-secondary-text">{label}:</span> {info || "-"}
  </Typography>
);

export default InfoPair;
